import * as React from "react";
import './Pick.css';
import '../../components/Typograph.css';
import ImageRadioPicker from "../../components/ImageRadioPicker";
import {Luiksluiting, Luikvastzetter} from "../../Model";
import geenLuikvastzetterImage from '../../images/luikvastzetter/geen luikvastzetter.jpg'
import herderinnekopjeImage from '../../images/luikvastzetter/herderinnekopje.jpg'
import hollandseLuikwervelImage from '../../images/luikvastzetter/hollandse.jpg'
import luikwervelMarseilleImage from '../../images/luikvastzetter/luikwervelMarseille.jpg'
import verborgenLuikvastzetterMacoImage from '../../images/luikvastzetter/luikvastzetterMaco.jpg'
import automatischeLuikvastzetterZwartImage from '../../images/luikvastzetter/automatisch.jpg'
import komfortLuikvastzetterImage from '../../images/luikvastzetter/komfortvastzetter Maco rustico onder het luik.jpg'
import verborgenLuikvastzetterImage from '../../images/luikvastzetter/verborgen luikvastzetter model F.jpg'
import comfortSluitingImage from '../../images/luikvastzetter/macoRusticoComfortsluiting.jpg'
import otherImage from "../../images/template/other1.png";
import PropTypes from "prop-types";
import PhoneAppHeader from "../../components/PhoneAppHeader";
import PickerInfoBox from "../../components/PickerInfoBox";
import PhoneAppFooter from "../../components/PhoneAppFooter";

FastenerPick.propTypes = {
    handleNextPage: PropTypes.func.isRequired,
    handlePreviousPage: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    allValues: PropTypes.object.isRequired,
    disablePhoneMode: PropTypes.func.isRequired,
}

const compatibilityClosings = [
    Luiksluiting.TYPE_A
]

const compatibilityFastener = [
    Luikvastzetter.VERBORGEN_LUIKVASTZETTER_MACO,
    Luikvastzetter.AUTOMATISCHE_LUIKVASTZETTER_ZWART,
    Luikvastzetter.COMFORT_SLUITING,
]

export default function FastenerPick(props) {
    const currentValue = props.allValues.FastenerPick;
    const closingValue = props.allValues.ClosingPick;

    const createErrorsOnMismatch = () => {
        if (!currentValue) return undefined;
        if (compatibilityClosings.includes(closingValue) && compatibilityFastener.includes(currentValue)) {
            return `De eerder gekozen luiksluiting '${closingValue}' kan niet worden gecombineerd met de
                    luikvastzetter '${currentValue}'.`;
        }
        return null;
    }

    return (
        <div className="page">
            <PhoneAppHeader title="Luikvastzetter"
                            quitPhoneApp={props.disablePhoneMode}
                            onPrevious={props.handlePreviousPage}/>

            <div className="phone-page-middle">
                <h1 className="phone-pick-title">Welke luikvastzetter moet deze situatie krijgen?</h1>
                <h1 className="phone-pick-title-sub">Het is mogelijk dat uw voorkeur niet altijd te combineren is met uw aanvraag. In dat geval zullen wij u een passend alternatief advies geven.</h1>

                <div className="phone-pick-body">
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.HERDERINNEKOPJE}
                                      image={herderinnekopjeImage}
                                      medium
                                      hintText={"herderinnekopje is alleen aan de onderkant van het luik te plaatsen"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.HOLLANDSE_LUIKWERVEL}
                                      image={hollandseLuikwervelImage}
                                      medium
                                      hintText={"hollandse luikwervel is alleen aan de onderkant van het luik te plaatsen"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.LUIKWERVEL_MARSEILLE}
                                      image={luikwervelMarseilleImage}
                                      medium
                                      hintText={"luikvastzetter Marseille is aan de onderkant en aan de zijkant van het luik te plaatsen"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.VERBORGEN_LUIKVASTZETTER_MACO}
                                      image={verborgenLuikvastzetterMacoImage}
                                      hintText={"verborgen luikvastzetter kan aan de (achter) zijkant geplaatst worden"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.VERBORGEN_LUIKVASTZETTER}
                                      image={verborgenLuikvastzetterImage}
                                      hintText={"verborgen luikvastzetter model F, kan aan de achter- of zijkant worden geplaatst"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.AUTOMATISCHE_LUIKVASTZETTER_ZWART}
                                      image={automatischeLuikvastzetterZwartImage}
                                      hintText={"automatische luikvastzetter is alleen aan de onderkant van het luik te plaatsen"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.COMFORT_SLUITING}
                                      image={comfortSluitingImage}
                                      hintText={"Maco Rustico Comfort vastzetter: achterzijde montage, binnenbediening voor verdiepingsluiken, alleen bij binnendraaiende ramen"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.COMFORT_ONDER_LUIKVASTZETTER}
                                      image={komfortLuikvastzetterImage}
                                      hintText={"Maco Rustico Comfort vastzetter: montage onder het luik, binnenbediening voor verdiepingsluiken, alleen bij binnendraaiende ramen"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.NO_FASTENER}
                                      image={geenLuikvastzetterImage}
                                      medium/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={{value: Luikvastzetter.OTHER, text: ""}}
                                      child
                                      medium
                                      image={otherImage}/>
                </div>
            </div>

            <PickerInfoBox
                options={[
                    {value: Luikvastzetter.HERDERINNEKOPJE, text: "herderinnekopje is alleen aan de onderkant van het luik te plaatsen"},
                    {value: Luikvastzetter.HOLLANDSE_LUIKWERVEL, text: "hollandse luikwervel is alleen aan de onderkant van het luik te plaatsen"},
                    {value: Luikvastzetter.LUIKWERVEL_MARSEILLE, text: "luikvastzetter Marseille is aan de onderkant en aan de zijkant van het luik te plaatsen"},
                    {value: Luikvastzetter.VERBORGEN_LUIKVASTZETTER_MACO, text: "verborgen luikvastzetter kan aan de (achter) zijkant geplaatst worden"},
                    {value: Luikvastzetter.AUTOMATISCHE_LUIKVASTZETTER_ZWART, text: "automatische luikvastzetter is alleen aan de onderkant van het luik te plaatsen"},
                    {value: Luikvastzetter.COMFORT_SLUITING, text: "Maco rustico comfort luikvastzetter is alleen aan de onderkant van het luik te plaatsen"},
                    {value: Luikvastzetter.NO_FASTENER, text: "Geen luikvastzetter"},
                    {value: Luikvastzetter.OTHER, text: "Omschrijf hier uw gewenste situatie", withInput: true},
                ]}
                current={currentValue}
                onChangeCurrent={props.handlePageChange}
                sticky
                warnings={createErrorsOnMismatch() == null ? [] : [createErrorsOnMismatch()]}
            />

            <PhoneAppFooter onNext={props.handleNextPage}
                            enableNext={!!currentValue && createErrorsOnMismatch() == null}/>
        </div>
    );
}
